<template>
  <div class="d-flex justify-end">
    <v-btn class="search-button" outlined color="success" @click="exportExcel">
      <v-icon left>mdi-file-excel</v-icon> Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import { baseHeaderExcel } from './helper'
import utils from '@/plugins/utils'
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  computed: { ...mapGetters({ customQuery: 'salaryReport/customQuery', detailPeriod: 'salaryPeriod/period' }) },
  methods: {
    ...mapActions({ exportDataExcel: 'salaryReport/exportDataExcel' }),
    async exportExcel() {
      this.$loading.active = true
      try {
        const listReport = await this.exportDataExcel({ ...this.customQuery, period: this.detailPeriod.id })

        const headers_sum = []
        const headers_minus = []
        const headers_tax = []
        listReport.forEach(r => {
          r.sumFees
            .map(i => i.name)
            .forEach(name => {
              if (!headers_sum.includes(name)) headers_sum.push(name)
            })
          r.minusFees
            .map(i => i.name)
            .forEach(name => {
              if (!headers_minus.includes(name)) headers_minus.push(name)
            })
          r.taxFees
            .map(i => i.name)
            .forEach(name => {
              if (!headers_tax.includes(name)) headers_tax.push(name)
            })
        })
        const headers = [
          ...baseHeaderExcel,
          ...headers_sum.map(i => ({ text: i, value: i })),
          ...headers_minus.map(i => ({ text: i, value: i })),
          ...headers_tax.map(i => ({ text: i, value: i })),
        ]
        console.log(headers)

        const filters = this.$options.filters
        const data = listReport
          .filter(r => r.teacher)
          .map(r => {
            const i = {}
            i.name = get(r, 'teacher.name', '')
            i.code = get(r, 'teacher.code', '')
            i.status = filters.teacherStatus(get(r, 'teacher.status', ''))
            // cấu thành lương
            r.sumFees.map(fee => (i[fee.name] = fee.value))
            // thuế và lương thực nhận
            r.taxFees.map(fee => (i[fee.name] = fee.value))
            // khoản truy thu
            r.minusFees.map(fee => (i[fee.name] = fee.value))
            return i
          })

        utils.exportExcel(
          data,
          headers,
          `Danh sách giáo viên tổng kết kì đóng ${filters.convertFullDate(this.detailPeriod.title)}`,
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
